import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// YENİ PROJE CONFIG: axiowar
const firebaseConfig = {
  apiKey: "AIzaSyBhib9zg0EbSAozTiiCV0rftwvTdFfdgfk",
  authDomain: "axiowar.firebaseapp.com",
  projectId: "axiowar",
  storageBucket: "axiowar.firebasestorage.app",
  messagingSenderId: "732652674323",
  appId: "1:732652674323:web:b5cec19474289134ff4ee6"
};

// Firebase'i Başlat
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);